import { render, staticRenderFns } from "./human-resources.vue?vue&type=template&id=3ee3b439&"
import script from "./human-resources.vue?vue&type=script&lang=js&"
export * from "./human-resources.vue?vue&type=script&lang=js&"
import style0 from "./human-resources.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports